/** 発送日未設定判定（表示上の発送日が空かどうか） */
export function isShipmentDateUnset(row) {
  if (!row) return true;
  const hasSplitPlans = Array.isArray(row.split_plans) && row.split_plans.length > 0;
  if (hasSplitPlans && row.split_plans.some((plan) => plan.shipment_date)) {
    return false;
  }
  return !(row.latest_shipment_date || row.shipment_date);
}

/** 発送日 td 用クラス（未設定時のみオレンジ背景） */
export function getShipmentDateUnsetCellClassName(isUnset) {
  return isUnset
    ? 'shipment-date-unset bg-amber-100 [&_input]:bg-transparent'
    : '';
}
